'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accident = require('./Icons/Accident');

var _Accident2 = _interopRequireDefault(_Accident);

var _AccordionDown = require('./Icons/AccordionDown');

var _AccordionDown2 = _interopRequireDefault(_AccordionDown);

var _AccordionUp = require('./Icons/AccordionUp');

var _AccordionUp2 = _interopRequireDefault(_AccordionUp);

var _Add = require('./Icons/Add');

var _Add2 = _interopRequireDefault(_Add);

var _Admin = require('./Icons/Admin');

var _Admin2 = _interopRequireDefault(_Admin);

var _ArrowBack = require('./Icons/ArrowBack');

var _ArrowBack2 = _interopRequireDefault(_ArrowBack);

var _ArrowDownSolid = require('./Icons/ArrowDownSolid');

var _ArrowDownSolid2 = _interopRequireDefault(_ArrowDownSolid);

var _ArrowLeft = require('./Icons/ArrowLeft');

var _ArrowLeft2 = _interopRequireDefault(_ArrowLeft);

var _ArrowRight = require('./Icons/ArrowRight');

var _ArrowRight2 = _interopRequireDefault(_ArrowRight);

var _ArrowUpSolid = require('./Icons/ArrowUpSolid');

var _ArrowUpSolid2 = _interopRequireDefault(_ArrowUpSolid);

var _Bookmark = require('./Icons/Bookmark');

var _Bookmark2 = _interopRequireDefault(_Bookmark);

var _Calendar = require('./Icons/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _Car = require('./Icons/Car');

var _Car2 = _interopRequireDefault(_Car);

var _ChartBar = require('./Icons/ChartBar');

var _ChartBar2 = _interopRequireDefault(_ChartBar);

var _Circle = require('./Icons/Circle');

var _Circle2 = _interopRequireDefault(_Circle);

var _ClipBoard = require('./Icons/ClipBoard');

var _ClipBoard2 = _interopRequireDefault(_ClipBoard);

var _Close = require('./Icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Declined = require('./Icons/Declined');

var _Declined2 = _interopRequireDefault(_Declined);

var _Delete = require('./Icons/Delete');

var _Delete2 = _interopRequireDefault(_Delete);

var _DragHandler = require('./Icons/DragHandler');

var _DragHandler2 = _interopRequireDefault(_DragHandler);

var _Edit = require('./Icons/Edit');

var _Edit2 = _interopRequireDefault(_Edit);

var _Enter = require('./Icons/Enter');

var _Enter2 = _interopRequireDefault(_Enter);

var _Error = require('./Icons/Error');

var _Error2 = _interopRequireDefault(_Error);

var _Export = require('./Icons/Export');

var _Export2 = _interopRequireDefault(_Export);

var _Eye = require('./Icons/Eye');

var _Eye2 = _interopRequireDefault(_Eye);

var _FilledBookmark = require('./Icons/FilledBookmark');

var _FilledBookmark2 = _interopRequireDefault(_FilledBookmark);

var _FilledSolidRedWarning = require('./Icons/FilledSolidRedWarning');

var _FilledSolidRedWarning2 = _interopRequireDefault(_FilledSolidRedWarning);

var _FilledSolidYellowWarning = require('./Icons/FilledSolidYellowWarning');

var _FilledSolidYellowWarning2 = _interopRequireDefault(_FilledSolidYellowWarning);

var _FilledWarning = require('./Icons/FilledWarning');

var _FilledWarning2 = _interopRequireDefault(_FilledWarning);

var _Filter = require('./Icons/Filter');

var _Filter2 = _interopRequireDefault(_Filter);

var _FilterSearch = require('./Icons/FilterSearch');

var _FilterSearch2 = _interopRequireDefault(_FilterSearch);

var _FuelCard = require('./Icons/FuelCard');

var _FuelCard2 = _interopRequireDefault(_FuelCard);

var _GraphView = require('./Icons/GraphView');

var _GraphView2 = _interopRequireDefault(_GraphView);

var _Info = require('./Icons/Info');

var _Info2 = _interopRequireDefault(_Info);

var _InProgress = require('./Icons/InProgress');

var _InProgress2 = _interopRequireDefault(_InProgress);

var _Link = require('./Icons/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Lock = require('./Icons/Lock');

var _Lock2 = _interopRequireDefault(_Lock);

var _Menu = require('./Icons/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _Minus = require('./Icons/Minus');

var _Minus2 = _interopRequireDefault(_Minus);

var _Notes = require('./Icons/Notes');

var _Notes2 = _interopRequireDefault(_Notes);

var _Notifications = require('./Icons/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

var _Overflow = require('./Icons/Overflow');

var _Overflow2 = _interopRequireDefault(_Overflow);

var _Phone = require('./Icons/Phone');

var _Phone2 = _interopRequireDefault(_Phone);

var _PoolBooking = require('./Icons/PoolBooking');

var _PoolBooking2 = _interopRequireDefault(_PoolBooking);

var _Profile = require('./Icons/Profile');

var _Profile2 = _interopRequireDefault(_Profile);

var _Quote = require('./Icons/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _Recent = require('./Icons/Recent');

var _Recent2 = _interopRequireDefault(_Recent);

var _RedBlackWarning = require('./Icons/RedBlackWarning');

var _RedBlackWarning2 = _interopRequireDefault(_RedBlackWarning);

var _Save = require('./Icons/Save');

var _Save2 = _interopRequireDefault(_Save);

var _SaveAs = require('./Icons/SaveAs');

var _SaveAs2 = _interopRequireDefault(_SaveAs);

var _Schedule = require('./Icons/Schedule');

var _Schedule2 = _interopRequireDefault(_Schedule);

var _Search = require('./Icons/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Settings = require('./Icons/Settings');

var _Settings2 = _interopRequireDefault(_Settings);

var _Share = require('./Icons/Share');

var _Share2 = _interopRequireDefault(_Share);

var _SolidRedWarning = require('./Icons/SolidRedWarning');

var _SolidRedWarning2 = _interopRequireDefault(_SolidRedWarning);

var _SolidYellowWarning = require('./Icons/SolidYellowWarning');

var _SolidYellowWarning2 = _interopRequireDefault(_SolidYellowWarning);

var _Source = require('./Icons/Source');

var _Source2 = _interopRequireDefault(_Source);

var _Submitted = require('./Icons/Submitted');

var _Submitted2 = _interopRequireDefault(_Submitted);

var _Success = require('./Icons/Success');

var _Success2 = _interopRequireDefault(_Success);

var _SuccessCircle = require('./Icons/SuccessCircle');

var _SuccessCircle2 = _interopRequireDefault(_SuccessCircle);

var _Suspended = require('./Icons/Suspended');

var _Suspended2 = _interopRequireDefault(_Suspended);

var _TableView = require('./Icons/TableView');

var _TableView2 = _interopRequireDefault(_TableView);

var _Tick = require('./Icons/Tick');

var _Tick2 = _interopRequireDefault(_Tick);

var _Time = require('./Icons/Time');

var _Time2 = _interopRequireDefault(_Time);

var _TrendDown = require('./Icons/TrendDown');

var _TrendDown2 = _interopRequireDefault(_TrendDown);

var _TrendMobileDown = require('./Icons/TrendMobileDown');

var _TrendMobileDown2 = _interopRequireDefault(_TrendMobileDown);

var _TrendMobileEqual = require('./Icons/TrendMobileEqual');

var _TrendMobileEqual2 = _interopRequireDefault(_TrendMobileEqual);

var _TrendMobileUp = require('./Icons/TrendMobileUp');

var _TrendMobileUp2 = _interopRequireDefault(_TrendMobileUp);

var _TrendNeutral = require('./Icons/TrendNeutral');

var _TrendNeutral2 = _interopRequireDefault(_TrendNeutral);

var _TrendUp = require('./Icons/TrendUp');

var _TrendUp2 = _interopRequireDefault(_TrendUp);

var _VehicleCondition = require('./Icons/VehicleCondition');

var _VehicleCondition2 = _interopRequireDefault(_VehicleCondition);

var _Warning = require('./Icons/Warning');

var _Warning2 = _interopRequireDefault(_Warning);

var _Aperture = require('./Icons/Aperture');

var _Aperture2 = _interopRequireDefault(_Aperture);

var _ArrowGoto = require('./Icons/ArrowGoto');

var _ArrowGoto2 = _interopRequireDefault(_ArrowGoto);

var _ArrowGoback = require('./Icons/ArrowGoback');

var _ArrowGoback2 = _interopRequireDefault(_ArrowGoback);

var _Budget = require('./Icons/Budget');

var _Budget2 = _interopRequireDefault(_Budget);

var _Camera = require('./Icons/Camera');

var _Camera2 = _interopRequireDefault(_Camera);

var _Claim = require('./Icons/Claim');

var _Claim2 = _interopRequireDefault(_Claim);

var _ErrorCircle = require('./Icons/ErrorCircle');

var _ErrorCircle2 = _interopRequireDefault(_ErrorCircle);

var _Fees = require('./Icons/Fees');

var _Fees2 = _interopRequireDefault(_Fees);

var _Finance = require('./Icons/Finance');

var _Finance2 = _interopRequireDefault(_Finance);

var _Fuel = require('./Icons/Fuel');

var _Fuel2 = _interopRequireDefault(_Fuel);

var _Insurance = require('./Icons/Insurance');

var _Insurance2 = _interopRequireDefault(_Insurance);

var _Maintenance = require('./Icons/Maintenance');

var _Maintenance2 = _interopRequireDefault(_Maintenance);

var _Others = require('./Icons/Others');

var _Others2 = _interopRequireDefault(_Others);

var _OthersCircle = require('./Icons/OthersCircle');

var _OthersCircle2 = _interopRequireDefault(_OthersCircle);

var _Registration = require('./Icons/Registration');

var _Registration2 = _interopRequireDefault(_Registration);

var _TickCircle = require('./Icons/TickCircle');

var _TickCircle2 = _interopRequireDefault(_TickCircle);

var _Tyres = require('./Icons/Tyres');

var _Tyres2 = _interopRequireDefault(_Tyres);

var _VehicleList = require('./Icons/VehicleList');

var _VehicleList2 = _interopRequireDefault(_VehicleList);

var _Winner = require('./Icons/Winner');

var _Winner2 = _interopRequireDefault(_Winner);

var _FuelPump = require('./Icons/FuelPump');

var _FuelPump2 = _interopRequireDefault(_FuelPump);

var _LeaseTerm = require('./Icons/LeaseTerm');

var _LeaseTerm2 = _interopRequireDefault(_LeaseTerm);

var _DriverWheel = require('./Icons/DriverWheel');

var _DriverWheel2 = _interopRequireDefault(_DriverWheel);

var _FailureCircle = require('./Icons/FailureCircle');

var _FailureCircle2 = _interopRequireDefault(_FailureCircle);

var _CloseCircle = require('./Icons/CloseCircle');

var _CloseCircle2 = _interopRequireDefault(_CloseCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Novated
exports.default = {
  accident: _Accident2.default,
  'accordion-up': _AccordionUp2.default,
  'accordion-down': _AccordionDown2.default,
  admin: _Admin2.default,
  add: _Add2.default,
  minus: _Minus2.default,
  'arrow-back': _ArrowBack2.default,
  'arrow-up-solid': _ArrowUpSolid2.default,
  'arrow-down-solid': _ArrowDownSolid2.default,
  'arrow-left': _ArrowLeft2.default,
  'arrow-right': _ArrowRight2.default,
  calendar: _Calendar2.default,
  car: _Car2.default,
  'chart-bar': _ChartBar2.default,
  close: _Close2.default,
  'clip-board': _ClipBoard2.default,
  circle: _Circle2.default,
  declined: _Declined2.default,
  delete: _Delete2.default,
  edit: _Edit2.default,
  error: _Error2.default,
  export: _Export2.default,
  'graph-view': _GraphView2.default,
  'in-progress': _InProgress2.default,
  link: _Link2.default,
  menu: _Menu2.default,
  save: _Save2.default,
  'save-as': _SaveAs2.default,
  schedule: _Schedule2.default,
  share: _Share2.default,
  submitted: _Submitted2.default,
  success: _Success2.default,
  'success-circle': _SuccessCircle2.default,
  'table-view': _TableView2.default,
  'drag-handler': _DragHandler2.default,
  filter: _Filter2.default,
  'filter-search': _FilterSearch2.default,
  'fuel-card': _FuelCard2.default,
  source: _Source2.default,
  overflow: _Overflow2.default,
  phone: _Phone2.default,
  'pool-booking': _PoolBooking2.default,
  profile: _Profile2.default,
  notifications: _Notifications2.default,
  quote: _Quote2.default,
  search: _Search2.default,
  settings: _Settings2.default,
  tick: _Tick2.default,
  time: _Time2.default,
  'trend-up': _TrendUp2.default,
  'trend-down': _TrendDown2.default,
  'trend-mobile-up': _TrendMobileUp2.default,
  'trend-mobile-down': _TrendMobileDown2.default,
  'trend-mobile-equal': _TrendMobileEqual2.default,
  'trend-neutral': _TrendNeutral2.default,
  'vehicle-condition': _VehicleCondition2.default,
  warning: _Warning2.default,
  recent: _Recent2.default,
  enter: _Enter2.default,
  eye: _Eye2.default,
  info: _Info2.default,
  'solid-red-warning': _SolidRedWarning2.default,
  'solid-yellow-warning': _SolidYellowWarning2.default,
  'filled-solid-red-warning': _FilledSolidRedWarning2.default,
  'filled-solid-yellow-warning': _FilledSolidYellowWarning2.default,
  'filled-warning': _FilledWarning2.default,
  suspended: _Suspended2.default,
  lock: _Lock2.default,
  'red-black-warning': _RedBlackWarning2.default,
  bookmark: _Bookmark2.default,
  'filled-bookmark': _FilledBookmark2.default,
  notes: _Notes2.default,

  // Novated
  aperture: _Aperture2.default,
  budget: _Budget2.default,
  claim: _Claim2.default,
  camera: _Camera2.default,
  fees: _Fees2.default,
  finance: _Finance2.default,
  fuel: _Fuel2.default,
  maintenance: _Maintenance2.default,
  others: _Others2.default,
  'others-circle': _OthersCircle2.default,
  insurance: _Insurance2.default,
  registration: _Registration2.default,
  tyres: _Tyres2.default,
  'arrow-goto': _ArrowGoto2.default,
  'arrow-goback': _ArrowGoback2.default,
  'vehicle-list': _VehicleList2.default,
  'tick-circle': _TickCircle2.default,
  'error-circle': _ErrorCircle2.default,
  winner: _Winner2.default,
  'fuel-pump': _FuelPump2.default,
  'lease-term': _LeaseTerm2.default,
  'driver-wheel': _DriverWheel2.default,
  'failure-circle': _FailureCircle2.default,
  'close-circle': _CloseCircle2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/iconList.js
// module id = 1287
// module chunks = 4